import React from 'react'
import PropTypes from 'prop-types'
import useLocale from 'js/hooks/useLocale'

function QuotationMarks({ children }) {
  const { language } = useLocale()

  if (language === 'no' || language === 'ru') return <>«{children}»</>
  if (language === 'fr') return <>«&nbsp;{children}&nbsp;»</>
  if (language === 'de') return <>„{children}“</>
  if (language === 'en' || language === 'es') return <>“{children}”</>
  return <>&quot;{children}&quot;</>
}

QuotationMarks.propTypes = {
  children: PropTypes.any,
}

export default QuotationMarks
